import classNames from 'classnames';

export const UserAccountTypeButton = ({ icon, onClick, title = '', subTitle = '', classes = '', active = false }): JSX.Element => {
  return (
    <button onClick={onClick} className={classNames('DAC7-icon-block-button', classes, { 'DAC7-icon-block-button--highlighted': active })}>
      <div className={classNames('DAC7-icon-block-button__icon', classes, { 'DAC7-icon-block-button__icon--highlighted': active })}>
        {icon}
      </div>
      <p className="DAC7-icon-block-button__title">{title}</p>
      <p className="DAC7-icon-block-button__sub-title">{subTitle}</p>
    </button>
  );
};
